(function ($, Drupal) {
  const productCarousel = function (context, settings) {

    $('.block-bi-product', context)
      // .once('init-block-bi-product')
      .each(function () {
        const contentBlockProduct = $(this);
        const contentBlockProductSelector = contentBlockProduct.find(
          '.swiper-container.product-slider',
          context
        );
        if (contentBlockProductSelector.length) {
          let sliderOptions = {
            loop: true,
            pagination: {
              el: '.swiper-pagination.product-pagination',
            },
            // Responsive breakpoints
            breakpoints: {
              992: {
                slidesPerView: 1,
              },
            },
          };

          // First thing we need to fetch slider settings from data attributes.
          new Swiper(contentBlockProductSelector[0], sliderOptions);
        }
      });
  }

  Drupal.behaviors.productBlock = {
    attach: function (context, settings) {
      productCarousel(context, settings);
      $(once('productBlock-sku-selector', '#product-sku-selector', context))
        .each(function (e) {
          $(this).on('change', function (e) {
            // Main Image.
            $('.product-images-sku').each(function() {
              $(this).removeClass('initial-state');
            });

            $('.product-images-sku, .product-images-sku .field__items > .field__item article').each(function() {
              $(this).addClass('hidden');
            });

            $('.product-images-sku.image-sku-id-' + $(this).val()).each(function() {
              $(this).removeClass('hidden');
            });

            $('.product-images-sku.image-sku-id-' + $(this).val() + ', .product-images-sku.image-sku-id-' + $(this).val() + ' .field__items > .field__item:first-of-type article').each(function() {
              $(this).removeClass('hidden');
            });

            // Carousel.
            let skuId = $(this).val();
            $('#product-carousel-sku').each(function() {
              $(this).html($('#carousel-sku-id-' + skuId).html());
            });

            productCarousel(context, settings);

            // Thumbnails.
            $('.product-thumbnails-sku').each(function() {
              $(this).addClass('hidden');
            });

            $('.product-thumbnails-sku.thumbnail-sku-id-' + $(this).val()).each(function() {
              $(this).removeClass('hidden');
            });
          })
        });

      const switchImage = function(el) {
        $('.product-images-sku').removeClass('initial-state');
        let id = $(el).data('media-id');
        $('.block-bi-product .product-images-sku .field__items > .field__item article').addClass('hidden');
        $('.block-bi-product .product-images-sku .field__items > .field__item article.media-id-' + id).removeClass('hidden');
      }

      $(once('productBlock', 'a.media--view-mode-product-thumbnail', context))
        .each(function (e) {

          // Switch image on "enter" or "space" keypress.
          $(document).on('keypress', $(this), function(e, thumb) {
            console.log('e.which', e.which);
            if (e.which === 13 || e.which === 32) {
              switchImage(e.target);
            }
          });

          $(this).on('click', function (e) {
            switchImage(this)
          });

        });

    }
  }
})(jQuery, Drupal);
